<template>
  <div id="app">
    <lt-nav-bar
      @back="onBack"
      :close="closeIcon"
      fixed
      :title="$route.meta && $route.meta.title"
    />
    <keep-alive include="">
      <router-view v-if="$route.meta && $route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { NavBar } from 'nldmx-ui';
import { closeWeb } from '@lutong/h5-utils/index';
import { changeWebviewBgOpacity } from './utils/webview';

export default {
	name: 'app',
	data() {
		return {
			closeIcon: true
		};
	},
	components: {
		[NavBar.name]: NavBar
	},
	watch: {
		$route: function(newRoute) {
			this.closeIcon = this.isFirstPage(newRoute);
		}
	},
	methods: {
		isFirstPage(route) {
			// 是否是app打开的第一个页面
			const { fullPath } = route;
			const { latestOpenUrl } = this.$baseInfo;
			const originHash = latestOpenUrl ? latestOpenUrl.split('#')[1] : '';

			return fullPath === originHash;
		},
		onBack() {
			if (this.isFirstPage(this.$route)) {
				// app打开的第一个页面
				closeWeb();
			} else {
				console.log('返回上一页');
				this.$router.back();
			}
		},
		onClose() {
			closeWeb();
		}
	},
	created() {
    // 全局监听实体按键返回
		this.$eventBus.on('backEvent', () => {
			this.onBack();
		});

		try {
			// 默认开启webview背景白色
			changeWebviewBgOpacity(1);
		} catch (err) {
			console.log(err);
		}
	}
};
</script>

<style lang="less">
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	background: #f5f5f5;
	min-height: 100%;
}
html {
	height: 100%;
}
body {
	height: 100%;
	box-sizing: border-box;
	padding-top: constant(safe-area-inset-top);
	padding-top: env(safe-area-inset-top);
}

.nav-bar_fixed {
	padding-top: constant(safe-area-inset-top);
	padding-top: env(safe-area-inset-top);
}
</style>
